// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__IKWHr","label":"style_label__3DiA3"};